import Vue from "vue";
import general from "./helpers/general";

Vue.filter("ucFirst", str => general.ucFirst(str));

Vue.filter("slug", str => general.slug(str));

Vue.filter("statusLabel", statusCode => general.statusLabel(statusCode));
